import { useState } from "react";
import { Button, Card } from "@/components/shared";

interface Props {
  selectedCount: number;
  maxSelections: number;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
}

export function SelectionConfirmModal({ selectedCount, maxSelections, onConfirm, onCancel, isLoading }: Props) {
  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <Card className="max-w-md w-full">
        <h2 className="text-xl font-bold text-white mb-2">Confirm Agent Selection</h2>
        <p className="text-white/60 mb-4">
          You've selected <span className="font-bold text-sun">{selectedCount}</span> agent(s)
          (max {maxSelections}). These agents will be invited to start a conversation with you.
        </p>

        <div className="bg-emerald-500/10 border border-emerald-500/20 rounded-lg p-3 mb-4">
          <p className="text-sm text-emerald-400">
            <strong>Privacy first:</strong> Your identity stays anonymous. You control the conversation
            and choose when — or if — to share your contact details.
          </p>
        </div>

        <div className="flex gap-3">
          <Button variant="secondary" onClick={onCancel} className="flex-1" disabled={isLoading}>
            Cancel
          </Button>
          <Button variant="primary" onClick={onConfirm} className="flex-1" disabled={isLoading}>
            {isLoading ? "Sending invitations..." : "Confirm & Invite"}
          </Button>
        </div>
      </Card>
    </div>
  );
}
